import { transformDTODate } from "@skylab-shared/core";
import { Transform, Type } from "class-transformer";
import { BankAccountStatus } from "../../bank-account/bank-account-status";
import { CalculationMethod } from "../../common/calculation-method";
import { DocumentBuyerDTO, DocumentClientDTO } from "../../document/dto/document-client.dto";
import { DocumentExchangeRateDTO } from "../../document/dto/document-exchange-rate.dto";
import { DocumentPaymentDTO } from "../../document/dto/document-payments.dto";
import { InventoryCostCalculationMethod } from "../../inventory/inventory-cost-calculation-method";
import { InventoryEffect } from "../../inventory/inventory-effect";
import { KsefSendSubmissionMode } from "../../ksef/ksef-send-submission-mode";
import { SplitPaymentState } from "../../sale/split-payment-state";
import { PurchaseDocumentKind } from "../purchase-document-kind";

class PurchaseDocumentSellerBankAccountDTO {
	public bankName: string;
	public number: string;
	public whiteListStatus: BankAccountStatus;
	@Transform(transformDTODate, { toClassOnly: true }) public whiteListLastDateCheck: Date | null;
	public whiteListCheckingId: string | null;
}

export class PurchaseDocumentDTO {
	public favourite: boolean;
	public calculationMethod: CalculationMethod.Gross | CalculationMethod.Net | CalculationMethod.Manual;
	public costCalculationMethod?: InventoryCostCalculationMethod;
	public cashBasis: boolean;
	public communityTransactionId: number;
	public currencyId: number;
    public ksefDocumentId?: string | null;
    public ksefSubmissionMode?: KsefSendSubmissionMode;
    public originalEInvoiceDocumentId?: number;
    @Transform(transformDTODate, { toClassOnly: true }) public deliveryDate?: Date;
	public documentNumber: string;
	@Transform(transformDTODate, { toClassOnly: true }) public dueDate: Date | null;
    public customDueDateDescription?: string | null;
	public inventoryEffect?: InventoryEffect | null;
	@Type(() => DocumentExchangeRateDTO) public exchangeRate: DocumentExchangeRateDTO | null;
	public expenseName?: string | null;
	public externalDocumentNumber: string;
	public fixedAsset: boolean;
	public id: number;
	@Transform(transformDTODate, { toClassOnly: true }) public issueDate: Date | null;
    public jpkVatDocumentGroups: string[];
	public kind: PurchaseDocumentKind;
	@Type(() => DocumentPaymentDTO) public payments: DocumentPaymentDTO[];
	public note: string;
	public numberingId: number;
	public paymentMethodId: number;
	@Transform(transformDTODate, { toClassOnly: true }) public receiptDate: Date | null;
	@Type(() => DocumentClientDTO) public seller: DocumentClientDTO | null;
	@Type(() => DocumentBuyerDTO) public supplier?: DocumentBuyerDTO | null;
	@Type(() => PurchaseDocumentSellerBankAccountDTO) public sellerBankAccount: PurchaseDocumentSellerBankAccountDTO | null;
	public splitPayment: SplitPaymentState;
	@Transform(transformDTODate, { toClassOnly: true }) public vatDeductionDate: Date;
	public transactionLocation: string | null;
	public relatedInventoryDocuments?: { id: number, version: string }[] | null;
	public issuer: string | null;
	public recipient: string | null;
	public automaticVatCalculation?: boolean;
	public adjustmentReason?: string;
	public issueGoodsReceiptAdjustment?: boolean;
	public duplicatePreventionId: string;
	public version: string;
}
